import { SpinnerLoader } from '../SearchResultComponent/styled';

export default function SearchLoader(props) {
  const {
    spinColor,
    mobileWidth = '18px',
    mobileHeight = '18px',
    desktopWidth = '30px',
    desktopHeight = '30px',
    topExtraMargin = '8px',
  } = props;
  const spinnerProps = {
    spinColor,
    mobileWidth,
    mobileHeight,
    desktopWidth,
    desktopHeight,
    topExtraMargin,
  };
  return (
    <SpinnerLoader {...spinnerProps}>
      <span className="smooth spinner" />
    </SpinnerLoader>
  );
}
